// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-button[data-v-ce1bbac2] {\n  width: var(--buttonWidth);\n  height: var(--buttonHeight);\n  background-repeat: no-repeat;\n  background-image: var(--normalImage);\n}\n.image-button[data-v-ce1bbac2]:hover {\n  background-image: var(--focusImage);\n}\n.image-button[data-v-ce1bbac2]:focus {\n  background-image: var(--focusImage);\n  outline: none;\n}\n.image-button[data-v-ce1bbac2]:active {\n  background-image: var(--pressedImage);\n}\n", ""]);
// Exports
module.exports = exports;
